
	//门店名称 联系人 联系电话 公司地址 有效期 
	const columnList: Array<any> = [
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "category",
				label: "类别",
				width: 200,
			},
			{
				prop: "project_name",
				label: "检车项",
				width: 100,
			},
			{
				prop: "project_standard",
				label: "标准值",
				width: 100,
			},
			{
				prop: "abnormal",
				label: "异常选项",
				width: 100,
			},
		]
	    
	];
	
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
	import { getframeworkList } from "@/api/http";
    import { storeUser } from "@/store/User";
	import {column} from "@/assets/types/common";
import axios from "axios";
import { Request } from "@/api/request";
	
	
	export default defineComponent({
	    name: "returnvisit",
		setup() {
		        const setTitle: any = inject("setTitle");
		        setTitle(["回访结果"]);
		        let pageSize = ref(10),
		            currentPage = ref(1),
                    user = storeUser.getUser(),
                    NavIndex = ref(0),
		            tableData = ref([] as Array<any>),
		            loading = ref(true),
					headClass = inject("headClass"),
					dialog_model = ref(""),
					formRef = ref(null),
					form = ref({} as any),
					dialog_index = ref(0),
					Router = useRouter(),
					screenParameter: any = {
						page: currentPage.value,
						pagesize: pageSize.value,
					},
				
		            getTableData = (): void => {
		                loading.value = true;
						screenParameter['page'] = currentPage.value
						screenParameter['pagesize'] = currentPage.value


                        Request.axiosInstance({
                            url: NavIndex.value == 3 ? 'adminapi/Carcheck/list' : 'adminapi/Basicset/list',
                            data: NavIndex.value == 3 ? screenParameter.valid : ({
                                basicset_type: (NavIndex.value == 0 ? 6 :
												NavIndex.value == 1 ? 7 :
												NavIndex.value == 2 ? 8 : 0)
                            })
                        }).then((res: any) => {
		                    tableData.value = res?.content?.list || [];
		                    loading.value = false;
		                });
		            },
					_option = (id: number, text: string) => {
						
					
						Router.push({
							path: '/framework/' + text,
							query: {
								id: id
							}
						})
					
					},
					_upState =(id: number, status: number) => {
						Request.axiosInstance({
							url:　 NavIndex.value == 3? 'adminapi/Carcheck/upState':'adminapi/Basicset/upState',
							data: NavIndex.value == 3 ? {id}: {basicset_id: id, status: status, basicset_type: (NavIndex.value == 0 ? 6 :
												NavIndex.value == 1 ? 7 :
												NavIndex.value == 2 ? 8 : 0)}
						}).then((res: any) => {
		                    res.status == 202 && getTableData()
		                });
					},
                    _nav = (index: number) => {
                        NavIndex.value = index
                        getTableData()
                    },
					_submitForm = () => {
						(formRef.value as any).validate((valid: boolean) => {
                    		if (!valid) return
							Request.axiosInstance({
								url:  dialog_model.value == 'edit' ? 'adminapi/Basicset/edit' :  'adminapi/Basicset/create' ,
								data: form.value
							}).then((res: any) => {
								res.status == 202 && (getTableData(), dialog_model.value ='')
							})
						})
					}
			
					
					
		        onMounted(() => {
					
							
					var router = useRoute();
					console.log(router)
						
				
					
					getTableData()
		        });
				

				watch(dialog_model, (newval, oldval) => {
					if(newval == 'add')
					{
						form.value ={
							basicset_name: '',
							basicset_order: '',
							basicset_type: (NavIndex.value == 0 ? 6 :
											NavIndex.value == 1 ? 7 :
											NavIndex.value == 2 ? 8 : 0)
						}
					
					}
					else if(newval == 'edit')
					{
						form.value ={
							basicset_id: tableData.value[dialog_index.value].basicset_id,
							basicset_name: tableData.value[dialog_index.value].basicset_name,
							basicset_order: tableData.value[dialog_index.value].basicset_order,
							basicset_type: tableData.value[dialog_index.value].basicset_type,
						}
					}
				})
				
		        return {
		            columnList,
		            tableData,
		            loading,
					headClass,
					screenParameter,
					Router,
					_option,
                    NavIndex,
                    _nav,
					_upState,
					dialog_model,
					dialog_index,
					form,
					formRef,
					_submitForm,
                    user
		        };
		    },
		});
		
